import {ISms} from "./sms.interface";
import {createSlice, current, PayloadAction} from "@reduxjs/toolkit";
import {autocompleteSms, downloadXLSX, fileDownload, getSms, getSmsList, loadMoreSms} from "./sms.request";
import {toast} from "react-toastify";

export type smsState = {
    sms: ISms | null;
    sms_list: ISms[];
    autocomplete: ISms[] | null;
    limit: number;
    offset: number;
    isLoading: boolean;
    isProccesCreateXLSX: boolean;
};

const initialState: smsState = {
    sms: null,
    sms_list: [],
    autocomplete: null,
    limit: 32,
    offset: 0,
    isLoading: false,
    isProccesCreateXLSX: false
};

const smsSlice = createSlice({
    name: "sms",
    initialState,
    reducers: {
        clearSms: (state) => {
            state.sms = null
        },
        clearSmsList: (state) => {
            state.sms_list = []
            state.offset = 0
        },
        clearAutocompleteSms: (state) => {
            state.autocomplete = null
        },
    },
    extraReducers: (builder) => {
        builder
            // get
            .addMatcher(
                (action) => action.type === getSms.pending.type,
                (state) => {
                    state.isLoading = true;
                }
            )
            .addMatcher(
                (action) => action.type === getSms.fulfilled.type,
                (state, action: PayloadAction<{sms: ISms}>) => {
                    state.sms = action.payload.sms
                    state.isLoading = false;
                }
            )
            .addMatcher(
                (action) => action.type === getSms.rejected.type,
                (state, action: any) => {
                    state.isLoading = false;
                }
            )
            // get all
            .addMatcher(
                (action) => action.type === getSmsList.pending.type,
                (state) => {
                    state.isLoading = true;
                }
            )
            .addMatcher(
                (action) => action.type === getSmsList.fulfilled.type,
                (state, action: PayloadAction<{sms_list: ISms[]}>) => {

                    state.sms_list = [...action.payload.sms_list]

                    state.offset = current(state).offset + current(state).limit + 1;

                    state.isLoading = false;
                }
            )
            .addMatcher(
                (action) => action.type === getSmsList.rejected.type,
                (state, action: any) => {
                    state.isLoading = false;
                }
            )
            // load more
            .addMatcher(
                (action) => action.type === loadMoreSms.pending.type,
                (state) => {
                    // state.isLoading = true;
                }
            )
            .addMatcher(
                (action) => action.type === loadMoreSms.fulfilled.type,
                (state, action: PayloadAction<{sms_list: ISms[]}>) => {
                    state.sms_list = [...current(state.sms_list), ...action.payload.sms_list]
                    // state.offset = current(state).offset + action.payload.sms_list.length || current(state).limit
                    state.offset = current(state).offset + current(state).limit + 1;
                }
            )
            .addMatcher(
                (action) => action.type === loadMoreSms.rejected.type,
                (state, action: any) => {
                    // state.isLoading = false;
                }
            )
            // autocomplete
            .addMatcher(
                (action) => action.type === autocompleteSms.pending.type,
                (state) => {
                    // state.isLoading = true;
                }
            )
            .addMatcher(
                (action) => action.type === autocompleteSms.fulfilled.type,
                (state, action: PayloadAction<{sms_list: ISms[] | null}>) => {
                    state.autocomplete = action.payload.sms_list
                }
            )
            .addMatcher(
                (action) => action.type === autocompleteSms.rejected.type,
                (state, action: any) => {
                    // state.isLoading = false;
                }
            )
        // download
            .addMatcher(
                (action) => action.type === downloadXLSX.pending.type,
                (state) => {
                    state.isProccesCreateXLSX = true;
                }
            )
            .addMatcher(
                (action) => action.type === downloadXLSX.fulfilled.type,
                (state, action) => {
                    state.isProccesCreateXLSX = false;
                    toast('A report generation request has been sent. You will receive a notification with download links.', {type: 'success'})
                }
            )
            .addMatcher(
                (action) => action.type === downloadXLSX.rejected.type,
                (state, action: any) => {
                    state.isProccesCreateXLSX = false;
                }
            )

            .addMatcher(
                (action) => action.type === fileDownload.pending.type,
                (state) => {
                }
            )
            .addMatcher(
                (action) => action.type === fileDownload.fulfilled.type,
                (state, action) => {
                }
            )
            .addMatcher(
                (action) => action.type === fileDownload.rejected.type,
                (state, action: any) => {

                }
            )


    },
});

export const { clearSms, clearSmsList, clearAutocompleteSms } = smsSlice.actions;

export default smsSlice.reducer;
